import React, { useState, useEffect } from "react";
// import configuration from "../../../config";
// import { toast } from "react-toastify";
// let Id = "";
function Summary({ data }) {
  const [profile, setProfile] = useState({});

  useEffect(() => {
    // var url = window.location.href;
    // Id = url.substring(url.lastIndexOf("/") + 1);
    // configuration
    //   .getAPI({ url: "sub-user/detail", params: { user_id: Id } })
    //   .then((data) => {
    //     if (data.status === 200) {
    let profileData = {
      "First Name": data.first_name,
      "Last Name": data.last_name,
      "Email ": data.email,
      Mobile: `${data.mobile_country_code} ${data.mobile}`,
      "Reg Date": data.created_at,
      Status: data.status,
    };
    setProfile(profileData);
    //     }
    //   })
    //   .catch((error) => {
    //     // console.log(error)
    //     return toast.error(error.message);
    //   });
    // console.log(configuration.baseURL);
  }, [data]);

  return (
    <div className="md:pl-8 sm:py-7 col-span-10">
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h2
              id="applicant-information-title"
              className="text-lg leading-6 font-medium text-gray-900"
            >
              Summary
            </h2>
            <p className="mt-1 max-w-2xl text-base text-gray-500 text_theme">
              This information is show dispatcher summary.
            </p>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div className="">
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                {Object.keys(profile).map((field) => (
                  <div key={field} className="sm:col-span-1">
                    <dt className="text-basefont-medium text-gray-500">
                      {field}
                    </dt>
                    <dd className="mt-1 text-base text-gray-900 md:break-all">
                      {profile[field]}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Summary;
